<template>
  <main class="home">
    <HeaderM3 :logoLinkRoute="M3_Welcome" />
    <div class="main-body d-flex flex-row">
      <div class="w-100">
        <NavigationBar :current-step="currentStep" />
        <SaleTimeOut />
        <div>
          <div v-if="isEcommerceFlow" class="container p-0">
            <GoogleAnalyticsEcommerceTracker />
            <OffersEcommerce />
          </div>
          <div v-else class="container p-0">
            <Offers />
          </div>
        </div>
      </div>
      <InConsoleSidebar />
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import Offers from "@/apps/merchant3/components/offers/Offers.vue";
import { useStore } from "vuex";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import NavigationBar from "@/apps/merchant3/shared-components/common/NavigationBar.vue";
import SaleTimeOut from "@/apps/merchant3/shared-components/common/SaleTimeout.vue";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";
import OffersEcommerce from "@/apps/merchant3/components/offers/OffersEcommerce.vue";
import { isEcommerceFlow } from "@/apps/merchant3/helpers/checkoutFlows";
import GoogleAnalyticsEcommerceTracker from "@/apps/merchant3/helpers/GoogleAnalyticsEcommerceTracker.vue";
import InConsoleSidebar from "@/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue";

const { t } = useI18n();
document.title = "PayJoy - " + t("PAGE_TITLE_OFFERS");

const store = useStore();
const M3_Welcome = ref(RouteName.M3Welcome);
const currentStep = ref(2);

onMounted(async () => {
  await store.dispatch("carts/setStep", RoutesPageSteps.Offers);

  useCartPersistState(() => true);
});
</script>
